import { render, staticRenderFns } from "./VisaTransferForm.vue?vue&type=template&id=0e696441&"
import script from "./VisaTransferForm.vue?vue&type=script&lang=js&"
export * from "./VisaTransferForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports